export default __webpack_public_path__ + "static/media/download-appstore-badge-en.ad4ecac3.svg";